import {Space} from "antd";
import {ProductGenInfoFormFieldsProps} from "./types";
import {ProductGenInfoNameFormField} from "./name-form-field";
import {ProductGenInfoDescriptionFormField} from "./description-form-field";

export function ProductGenInfoFormFields({
  nameFieldId,
  nameFieldLabel,
  nameFieldPlaceholder,
  descriptionFieldId,
  descriptionFieldLabel,
  descriptionFieldPlaceholder,
  coverImageFieldId,
  coverImageFieldLabel,
  coverImageFieldPlaceholder,
}: ProductGenInfoFormFieldsProps) {
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <ProductGenInfoNameFormField
          id={nameFieldId}
          label={nameFieldLabel}
          placeholder={nameFieldPlaceholder}
        />
        <ProductGenInfoDescriptionFormField
          id={descriptionFieldId}
          label={descriptionFieldLabel}
          placeholder={descriptionFieldPlaceholder}
        />
      </Space>
    </div>
  );
}
